import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('message-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('message', {
        parent: 'arw',
        abstract: true,
        url: '/messages',
        template: '<div ui-view></div>',
      })
      .state('message.list', {
        url: '',
        template: `<messages-tab></messages-messages-tab>`,
        redirectTo: 'permissions-denied',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('All Messages')));
            },
          ],
        },
      })
      .state('message.sent', {
        url: '/sent/details/:id',
        template: '<sent-message-details sent-message-id="$resolve.id"></sent-message-details>',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Sent - Message details')));
            },
          ],
        },
        resolve: {
          id: ['$stateParams', ($stateParams) => $stateParams.id],
        },
      })
      .state('message.view', {
        url: '/details/:id',
        template: '<message-details user-message-id="$resolve.id"></message-details>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Inbox - Message details')));
            },
          ],
        },
        resolve: {
          id: ['$stateParams', ($stateParams) => $stateParams.id],
        },
      })
      .state('message.create', {
        url: '/message-create',
        template: `<create-message></create-message>`,
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Inbox - Create Message')));
            },
          ],
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/message/message-routing-module.js